import styled from 'styled-components';

export const ImageSlice = styled.div`
  width: 470px;
  height: 282px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-image: ${(props) => `url('${props.image}')`};
  z-index: 1;
`;
